import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconPlay = ({
    width = '16',
    height = '16',
    className = '',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M3.891 14.824A1.253 1.253 0 0 1 2 13.748V2.252a1.253 1.253 0 0 1 1.913-1.063l9.421 5.692a1.273 1.273 0 0 1 0 2.238l-9.43 5.698-.013.007z"
            />
        </svg>
    );
};

export default IconPlay;
